// import React, { useState, useRef, useEffect } from 'react';
// import { Search, Plus, Lock, FileText, MoreHorizontal, ChevronLeft, ChevronRight, ChevronDown } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import styles from '../StudyManagement.module.css';
// import { checkUserConsent } from '../../../Config/api';

// const SubjectsTable = ({
//   subjects,
//   sites,
//   canWrite,
//   onCreateClick,
//   onViewSubject,
//   onEditSubject,
//   onDeleteSubject,
//   onLockSubject
// }) => {
//   const navigate = useNavigate();
//   const [searchTerm, setSearchTerm] = useState('');
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [openActionMenu, setOpenActionMenu] = useState(null);
//   const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
//   const [checkingConsent, setCheckingConsent] = useState(false);
//   const menuRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setOpenActionMenu(null);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   const handleCreateSubjectClick = async () => {
//     try {
//       setCheckingConsent(true);

//       const consentData = await checkUserConsent();

//       setCheckingConsent(false);

//       if (consentData.showConsent === true) {
//         alert('Please fill the consent form first before creating a subject.');

//         const storedUser = JSON.parse(localStorage.getItem('user'));

//         navigate('/service-agreement', {
//           state: {
//             userData: storedUser
//           },
//           replace: true
//         });
//       } else {
//         onCreateClick();
//       }
//     } catch (error) {
//       setCheckingConsent(false);
//       console.error('Error checking consent:', error);

//       alert('Unable to verify consent status. Please try again.');
//     }
//   };

//   const handleMenuOpen = (index, event) => {
//     if (openActionMenu === index) {
//       setOpenActionMenu(null);
//     } else {
//       const button = event.currentTarget;
//       const rect = button.getBoundingClientRect();
//       const menuHeight = 230;
//       const menuWidth = 160;
//       const viewportHeight = window.innerHeight;
//       const viewportWidth = window.innerWidth;
//       const spaceBelow = viewportHeight - rect.bottom;
//       const spaceAbove = rect.top;
//       const openUpwards = spaceBelow < menuHeight && spaceAbove > menuHeight;
//       const spaceOnRight = viewportWidth - rect.right;
//       const spaceOnLeft = rect.left;
//       const alignToLeft = spaceOnRight < menuWidth && spaceOnLeft > spaceOnRight;

//       setMenuPosition({
//         top: openUpwards ? rect.top - menuHeight : rect.bottom,
//         left: alignToLeft ? rect.left - menuWidth + 20 : rect.right - menuWidth
//       });
//       setOpenActionMenu(index);
//     }
//   };

//   const handleAction = (action, subject) => {
//     setOpenActionMenu(null);
//     if (action === 'View') onViewSubject(subject);
//     else if (action === 'Edit') onEditSubject(subject);
//     else if (action === 'Delete') {
//       if (window.confirm(`Are you sure you want to delete subject ${subject.subjectId}?`)) {
//         onDeleteSubject(subject.subjectId);
//       }
//     } else if (action === 'Lock Subject') onLockSubject(subject.subjectId);
//     else if (action === 'History') console.log('Showing history for:', subject.subjectId);
//   };

//   const handleDataCaptureClick = (subject) => {
//     console.log('Starting data capture for subject:', subject);

//     let studyId = subject.studyId;

//     if (!studyId && subject.siteId && sites && sites.length > 0) {
//       const site = sites.find(s => s.id === subject.siteId);
//       if (site) {
//         studyId = site.studyId;
//       }
//     }

//     if (!studyId) {
//       studyId = 1;
//     }

//     console.log('Navigating to study:', studyId);

//     navigate(`/survey/${studyId}`, {
//       state: {
//         subject: {
//           subjectId: subject.subjectId,
//           siteId: subject.siteId,
//           siteName: subject.siteName,
//           studyId: studyId
//         }
//       }
//     });
//   };

//   return (
//     <div className={styles.tableContainer}>
//       <div className={styles.tableHeader}>
//         <div className={styles.tableHeaderTop}>
//           <h2 className={styles.tableTitle}>Subject Management</h2>
//           {canWrite && (
//             <button
//               className={styles.createButton}
//               onClick={handleCreateSubjectClick}
//               disabled={checkingConsent}
//             >
//               <Plus size={18} />
//               {checkingConsent ? 'Checking...' : 'Create Subject'}
//             </button>
//           )}
//         </div>

//         <div className={styles.tableActions}>
//           <div className={styles.searchContainer}>
//             <Search className={styles.searchIcon} size={18} />
//             <input
//               type="text"
//               placeholder="Search..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className={styles.searchInput}
//             />
//           </div>
//           <div className={styles.actionButtons}>
//             <button className={styles.actionButton}>Customize</button>
//             <button className={styles.actionButton}>Export</button>
//           </div>
//         </div>
//       </div>

//       <div className={styles.tableWrapper}>
//         <table className={styles.table}>
//           <thead className={styles.tableHead}>
//             <tr>
//               <th className={styles.tableHeadCell}>
//                 Site Name <ChevronDown size={14} className={styles.sortIcon} />
//               </th>
//               <th className={styles.tableHeadCell}>
//                 Subject ID <ChevronDown size={14} className={styles.sortIcon} />
//               </th>
//               <th className={styles.tableHeadCell}>
//                 Subject Initials <ChevronDown size={14} className={styles.sortIcon} />
//               </th>
//               <th className={styles.tableHeadCell}>
//                 Date of Enrollment <ChevronDown size={14} className={styles.sortIcon} />
//               </th>
//               <th className={styles.tableHeadCell}>
//                 Enrollment Status <ChevronDown size={14} className={styles.sortIcon} />
//               </th>
//               <th className={styles.tableHeadCell}>Progress</th>
//               <th className={styles.tableHeadCell}>Data Capture</th>
//               <th className={styles.tableHeadCell}>
//                 Lock Status <ChevronDown size={14} className={styles.sortIcon} />
//               </th>
//               <th className={styles.tableHeadCell}>Actions</th>
//             </tr>
//           </thead>
//           <tbody className={styles.tableBody}>
//             {subjects.map((subject, index) => (
//               <tr key={index} className={styles.tableRow}>
//                 <td className={styles.tableCell}>{subject.site_name}</td>
//                 <td className={styles.tableCellBold}>{subject.subjectId}</td>
//                 <td className={styles.tableCell}>{subject.subjectInitials}</td>
//                 <td className={styles.tableCell}>{subject.dateOfEnrollment}</td>
//                 <td className={styles.tableCell}>
//                   <span className={`${styles.statusBadge} ${subject.enrollmentStatus === 'Screening' ? styles.statusScreening : styles.statusEnrolled
//                     }`}>
//                     {subject.enrollmentStatus}
//                   </span>
//                 </td>
//                 <td className={styles.tableCell}>
//                   <span className={styles.progressText}>{subject.progress}%</span>
//                 </td>
//                 <td className={styles.tableCellCenter}>
//                   {subject.dataCaptureIcon && (
//                     <button
//                       onClick={() => handleDataCaptureClick(subject)}
//                       className={styles.dataCaptureButton}
//                       title="Start Data Capture"
//                     >
//                       <FileText size={18} className={styles.icon} />
//                     </button>
//                   )}
//                 </td>
//                 <td className={styles.tableCellCenter}>
//                   <Lock
//                     size={18}
//                     className={subject.lockStatus === 'locked' ? styles.iconLocked : styles.iconLock}
//                   />
//                 </td>
//                 <td className={styles.tableCellCenter}>
//                   <div className={styles.actionMenuWrapper} ref={openActionMenu === index ? menuRef : null}>
//                     <button className={styles.moreButton} onClick={(e) => handleMenuOpen(index, e)}>
//                       <MoreHorizontal size={18} />
//                     </button>
//                     {openActionMenu === index && (
//                       <div className={styles.actionMenu} style={{ top: `${menuPosition.top}px`, left: `${menuPosition.left}px` }}>
//                         <button className={styles.actionMenuItem} onClick={() => handleAction('View', subject)}>
//                           View
//                         </button>
//                         {canWrite && (
//                           <>
//                             <button className={styles.actionMenuItem} onClick={() => handleAction('Edit', subject)}>
//                               Edit
//                             </button>
//                             <button className={styles.actionMenuItem} onClick={() => handleAction('Lock Subject', subject)}>
//                               {subject.lockStatus === 'locked' ? 'Unlock Subject' : 'Lock Subject'}
//                             </button>
//                             <button className={styles.actionMenuItem} onClick={() => handleAction('History', subject)}>
//                               History
//                             </button>
//                             <button className={`${styles.actionMenuItem} ${styles.actionMenuItemDanger}`} onClick={() => handleAction('Delete', subject)}>
//                               Delete
//                             </button>
//                           </>
//                         )}
//                       </div>
//                     )}
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       <div className={styles.pagination}>
//         <div className={styles.rowsPerPage}>
//           <span className={styles.paginationLabel}>Rows per page:</span>
//           <select value={rowsPerPage} onChange={(e) => setRowsPerPage(Number(e.target.value))} className={styles.rowsSelect}>
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//           </select>
//         </div>
//         <div className={styles.paginationControls}>
//           <span className={styles.pageInfo}>Page 1 of 1</span>
//           <div className={styles.paginationButtons}>
//             <button className={styles.paginationButton}><ChevronLeft size={18} /></button>
//             <button className={styles.paginationButton}><ChevronLeft size={18} /></button>
//             <button className={styles.paginationButton}><ChevronRight size={18} /></button>
//             <button className={styles.paginationButton}><ChevronRight size={18} /></button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SubjectsTable;

import React, { useState, useRef, useEffect } from 'react';
import { Search, Plus, Lock, FileText, MoreHorizontal, ChevronLeft, ChevronRight, ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import styles from '../StudyManagement.module.css';
import { checkUserConsent } from '../../../Config/api';

const SubjectsTable = ({
  subjects,
  sites,
  canWrite,
  canDataCapture,
  onCreateClick,
  onViewSubject,
  onEditSubject,
  onDeleteSubject,
  onLockSubject
}) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [checkingConsent, setCheckingConsent] = useState(false);
  const menuRef = useRef(null);
  const formatDateTime = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenActionMenu(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleCreateSubjectClick = async () => {
    try {
      setCheckingConsent(true);

      const consentData = await checkUserConsent();

      setCheckingConsent(false);

      if (consentData.showConsent === true) {
        alert('Please fill the consent form first before creating a subject.');

        const storedUser = JSON.parse(localStorage.getItem('user'));

        navigate('/service-agreement', {
          state: {
            userData: storedUser
          },
          replace: true
        });
      } else {
        onCreateClick();
      }
    } catch (error) {
      setCheckingConsent(false);
      console.error('Error checking consent:', error);

      alert('Unable to verify consent status. Please try again.');
    }
  };

  const handleMenuOpen = (index, event) => {
    if (openActionMenu === index) {
      setOpenActionMenu(null);
    } else {
      const button = event.currentTarget;
      const rect = button.getBoundingClientRect();
      const menuHeight = 230;
      const menuWidth = 160;
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;
      const spaceBelow = viewportHeight - rect.bottom;
      const spaceAbove = rect.top;
      const openUpwards = spaceBelow < menuHeight && spaceAbove > menuHeight;
      const spaceOnRight = viewportWidth - rect.right;
      const spaceOnLeft = rect.left;
      const alignToLeft = spaceOnRight < menuWidth && spaceOnLeft > spaceOnRight;

      setMenuPosition({
        top: openUpwards ? rect.top - menuHeight : rect.bottom,
        left: alignToLeft ? rect.left - menuWidth + 20 : rect.right - menuWidth
      });
      setOpenActionMenu(index);
    }
  };

  const handleAction = (action, subject) => {
    setOpenActionMenu(null);
    if (action === 'View') onViewSubject(subject);
    else if (action === 'Edit') onEditSubject(subject);
    else if (action === 'Delete') {
      if (window.confirm(`Are you sure you want to delete subject ${subject.subjectId}?`)) {
        onDeleteSubject(subject.subjectId);
      }
    } else if (action === 'Lock Subject') onLockSubject(subject.subjectId);
    else if (action === 'History') console.log('Showing history for:', subject.subjectId);
  };

  const handleDataCaptureClick = async (subject) => {
    console.log('Starting data capture for subject:', subject);

    try {
      setCheckingConsent(true);

      const consentData = await checkUserConsent();

      setCheckingConsent(false);

      if (consentData.showConsent === true) {
        alert('Please fill the consent form first before accessing data capture.');

        const storedUser = JSON.parse(localStorage.getItem('user'));
        console.log('Navigating to consent with user data:', storedUser);

        navigate('/service-agreement', {
          state: {
            userData: storedUser,
            returnTo: 'dataCapture',
            subject: subject
          },
          replace: true
        });
        return;
      }

      // let studyId = subject.studyId;

      // if (!studyId && subject.siteId && sites && sites.length > 0) {
      //   const site = sites.find(s => s.id === subject.siteId);
      //   if (site) {
      //     studyId = site.studyId;
      //   }
      // }

      // if (!studyId) {
      //   studyId = 1;
      // }
      console.log(";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;", subject)

      let studyId = subject.studyId;

      if (!studyId && subject.siteId && sites && sites.length > 0) {
        const site = sites.find(s => s.siteId === subject.siteId);
        if (site) {
          studyId = site.studyId;
        }
      }



      console.log('Navigating to study:', studyId);

      navigate(`/survey/${studyId}`, {
        state: {
          subject: {
            subjectId: subject.subjectId,
            siteId: subject.siteId,
            siteName: subject.siteName,
            studyId: studyId
          }
        }
      });
    } catch (error) {
      setCheckingConsent(false);
      console.error('Error checking consent:', error);
      alert('Unable to verify consent status. Please try again.');
    }
  };

  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableHeader}>
        <div className={styles.tableHeaderTop}>
          <h2 className={styles.tableTitle}>Subject Management</h2>
          {canDataCapture && (
            <button
              className={styles.createButton}
              onClick={handleCreateSubjectClick}
              disabled={checkingConsent}
            >
              <Plus size={18} />
              {checkingConsent ? 'Checking...' : 'Create Subject'}
            </button>
          )}
        </div>

        <div className={styles.tableActions}>
          <div className={styles.searchContainer}>
            <Search className={styles.searchIcon} size={18} />
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
            />
          </div>
          {/* <div className={styles.actionButtons}>
            <button className={styles.actionButton}>Customize</button>
            <button className={styles.actionButton}>Export</button>
          </div> */}
        </div>
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead className={styles.tableHead}>
            <tr>
              <th className={styles.tableHeadCell}>
                Site Name <ChevronDown size={14} className={styles.sortIcon} />
              </th>
              <th className={styles.tableHeadCell}>
                Subject ID <ChevronDown size={14} className={styles.sortIcon} />
              </th>
              <th className={styles.tableHeadCell}>
                Subject Initials <ChevronDown size={14} className={styles.sortIcon} />
              </th>
              <th className={styles.tableHeadCell}>
                Date of Enrollment <ChevronDown size={14} className={styles.sortIcon} />
              </th>
              <th className={styles.tableHeadCell}>
                Enrollment Status <ChevronDown size={14} className={styles.sortIcon} />
              </th>
              <th className={styles.tableHeadCell}>Progress</th>
              {canDataCapture && (
                <th className={styles.tableHeadCell}>Data Capture</th>
              )}
              {/* <th className={styles.tableHeadCell}>
                Lock Status <ChevronDown size={14} className={styles.sortIcon} />
              </th> */}
              <th className={styles.tableHeadCell}>Actions</th>
            </tr>
          </thead>
          <tbody className={styles.tableBody}>
            {subjects.length === 0 ? (
              <tr>
                <td colSpan={canDataCapture ? 9 : 8} className={styles.noDataCell}>
                  <div className={styles.noDataMessage}>
                    No subject data available.
                  </div>
                </td>
              </tr>
            ) : (
              subjects.map((subject, index) => (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.tableCell}>{subject.siteName}</td>
                  <td className={styles.tableCellBold}>{subject.subjectId}</td>
                  <td className={styles.tableCell}>{subject.subjectInitials}</td>
                  <td className={styles.tableCell}>{formatDateTime(subject.dateOfEnrollment)}</td>
                  <td className={styles.tableCell}>
                    <span className={`${styles.statusBadge} ${subject.enrollmentStatus === 'Screening' ? styles.statusScreening : styles.statusEnrolled}`}>
                      {subject.enrollmentStatus}
                    </span>
                  </td>
                  <td className={styles.tableCell}>
                    <span className={styles.progressText}>{subject.progress}%</span>
                  </td>
                  {canDataCapture && (
                    <td className={styles.tableCellCenter}>
                      {subject.dataCaptureIcon && (
                        <button
                          onClick={() => handleDataCaptureClick(subject)}
                          className={styles.dataCaptureButton}
                          title="Start Data Capture"
                          disabled={checkingConsent}
                        >
                          <FileText size={18} className={styles.icon} />
                        </button>
                      )}
                    </td>
                  )}
                  {/* <td className={styles.tableCellCenter}>
                    <Lock
                      size={18}
                      className={subject.lockStatus === 'locked' ? styles.iconLocked : styles.iconLock}
                    />
                  </td> */}
                  <td className={styles.tableCellCenter}>
                    <div className={styles.actionMenuWrapper} ref={openActionMenu === index ? menuRef : null}>
                      <button className={styles.moreButton} onClick={(e) => handleMenuOpen(index, e)}>
                        <MoreHorizontal size={18} />
                      </button>
                      {openActionMenu === index && (
                        <div className={styles.actionMenu} style={{ top: `${menuPosition.top}px`, left: `${menuPosition.left}px` }}>
                          <button className={styles.actionMenuItem} onClick={() => handleAction('View', subject)}>
                            View
                          </button>
                          {canWrite && (
                            <>
                              <button className={styles.actionMenuItem} onClick={() => handleAction('Edit', subject)}>
                                Edit
                              </button>
                              {/* <button className={styles.actionMenuItem} onClick={() => handleAction('Lock Subject', subject)}>
                                {subject.lockStatus === 'locked' ? 'Unlock Subject' : 'Lock Subject'}
                              </button> */}
                              <button className={styles.actionMenuItem} onClick={() => handleAction('History', subject)}>
                                History
                              </button>
                              <button className={`${styles.actionMenuItem} ${styles.actionMenuItemDanger}`} onClick={() => handleAction('Delete', subject)}>
                                Delete
                              </button>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className={styles.pagination}>
        <div className={styles.rowsPerPage}>
          <span className={styles.paginationLabel}>Rows per page:</span>
          <select value={rowsPerPage} onChange={(e) => setRowsPerPage(Number(e.target.value))} className={styles.rowsSelect}>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
        </div>
        <div className={styles.paginationControls}>
          <span className={styles.pageInfo}>Page 1 of 1</span>
          <div className={styles.paginationButtons}>
            <button className={styles.paginationButton}><ChevronLeft size={18} /></button>
            <button className={styles.paginationButton}><ChevronLeft size={18} /></button>
            <button className={styles.paginationButton}><ChevronRight size={18} /></button>
            <button className={styles.paginationButton}><ChevronRight size={18} /></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubjectsTable;